/**
 * Il contatto del supporto sotto le pagine d'accesso: la mail e, se c'è, lo stato del servizio.
 * Viene da `usePlatformIdentity` (task 2061): un contatto che il superadmin lascia vuoto non compare.
 */
import { Anchor } from '@mantine/core';
import { usePlatformIdentity } from './platformIdentity';

export function SupportContact({ withStatus = false, color }: { withStatus?: boolean; color?: string }) {
  const p = usePlatformIdentity();
  return (
    <>
      {p.supportEmail && (
        <Anchor href={`mailto:${p.supportEmail}`} size="xs" c={color}>{p.supportEmail}</Anchor>
      )}
      {withStatus && p.statusUrl && (
        <>
          {p.supportEmail ? ' · ' : ''}
          <Anchor href={p.statusUrl} target="_blank" rel="noopener noreferrer" size="xs" c={color}>
            Stato servizio
          </Anchor>
        </>
      )}
    </>
  );
}
